import { endpointRenewSubscription } from "../firebase/endpoints";
import axios from "axios";
import { handlerAxiosErrors } from "lib/helpers/helperFunctions";
import { axiosConfig } from "lib/constants/axiosConstant";

export const renewSubscriptionPlan = async (
  transactionReceipt,
  stripeCustomer,
  uid,
  subscriptionPlan
) => {
  let body = {
    sub: transactionReceipt,
    stripeUserId: stripeCustomer,
    userId: uid,
    price: subscriptionPlan,
  };

  let renewedSubscription = await axios
    .post(endpointRenewSubscription, body, axiosConfig)
    .catch((err) => handlerAxiosErrors(err));
  return renewedSubscription;
};
